var map = {
	"./cs/settings.json": 7783,
	"./de/settings.json": 6390,
	"./en/settings.json": 4369,
	"./es/settings.json": 9952,
	"./fr/settings.json": 562,
	"./it/settings.json": 6473,
	"./pl/settings.json": 3878,
	"./ru/settings.json": 468,
	"./tr/settings.json": 7135,
	"./uk/settings.json": 574,
	"./zh-CN/settings.json": 3400,
	"./zh-TW/settings.json": 3308
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3656;